import {
    noDateGroupLabel,
    laterGroupLabel,
    nextWeekGroupLabel,
    tomorrowGroupLabel,
    todayGroupLabel,
} from './getGroupHeaderForFlagDueDate.locstring.json';
import loc from 'owa-localize';
import type GroupHeader from '../type/GroupHeader';
import { FlagDueDateHeaderId } from '../type/GroupHeaderId';
import type { TableView } from 'owa-mail-list-store';
import { MailRowDataPropertyGetter } from 'owa-mail-list-store';
import { userDate, addDays, startOfDay } from 'owa-datetime';

/**
 * Get GroupHeader for row when sorted by FlagDueDate.
 * Buckets a row into one of five groups: NoDate, Today, Tomorrow, NextWeek, Later.
 * @param rowKey rowKey for which we want to lookup the flag due date group
 * @param tableView tableView
 * @return group header for this row
 */
export default function getGroupHeaderForFlagDueDate(
    rowKey: string,
    tableView: TableView
): GroupHeader {
    const flagDueDate = MailRowDataPropertyGetter.getFlagDueDate(rowKey, tableView);
    if (!flagDueDate) {
        return {
            headerText: () => loc(noDateGroupLabel),
            headerId: FlagDueDateHeaderId.NoDate,
        };
    }

    const todayStart = startOfDay(userDate());
    const due = startOfDay(userDate(flagDueDate)).valueOf();

    if (due < addDays(todayStart, 1).valueOf()) {
        return {
            headerText: () => loc(todayGroupLabel),
            headerId: FlagDueDateHeaderId.Today,
        };
    }
    if (due < addDays(todayStart, 2).valueOf()) {
        return {
            headerText: () => loc(tomorrowGroupLabel),
            headerId: FlagDueDateHeaderId.Tomorrow,
        };
    }
    if (due < addDays(todayStart, 8).valueOf()) {
        return {
            headerText: () => loc(nextWeekGroupLabel),
            headerId: FlagDueDateHeaderId.NextWeek,
        };
    }
    return {
        headerText: () => loc(laterGroupLabel),
        headerId: FlagDueDateHeaderId.Later,
    };
}
